import script from "./ABSTrafficFinesReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ABSTrafficFinesReport.vue?vue&type=script&setup=true&lang=js"

import "./ABSTrafficFinesReport.vue?vue&type=style&index=0&id=0cbfb5af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cbfb5af"]])

export default __exports__